import React from 'react';
import { Card, Loader, ApplicantExamDetailsTabs } from 'components';
import { AppType } from 'components/enums';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';

const ApplicationExamDetailsContainer = ({
    getExamApplicationDetails,
    examApplicationId,
    applicationDetails,
    examDetails,
    onGoBack,
    withoutCard,
    loading,
    apiError,
}: IProps) => {
    React.useEffect(() => {
        getExamApplicationDetails(examApplicationId);
    }, []);

    const renderTabs = () => (examDetails ? (
        <ApplicantExamDetailsTabs
          appType={AppType.Ec}
          examDetails={examDetails}
          examApplication={applicationDetails}
          resultAndStatusCardCategory={null}
          resultAndStatusCardTitle={null}
          withoutExpertsTab
          withoutInfoTab
          withoutRulesTab
        />
    ) : null);

    if (withoutCard) {
        if (loading) return <Loader />;
        return renderTabs();
    }

    const title = applicationDetails ? `${applicationDetails.applicant.lastName} ${applicationDetails.applicant.firstName} ${applicationDetails.applicant.middleName}` : '';

    return (
        <Card
          title={title}
          category="Информация по экзамену"
          withBackButton
          withoutPadding
          onClickBack={onGoBack}
          showLoader={loading}
          apiError={apiError}
        >
            {renderTabs()}
        </Card>
    );
};

const mapState = (state: IRootState) => ({
    applicationDetails: state.examApplications.applicationDetails,
    examDetails: state.examApplications.examDetails,
    loading: Boolean(state.loading.models.examApplications),
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    getExamApplicationDetails: dispatch.examApplications.getExamApplicationDetailsAsync,
    onPush: (key: string) => dispatch(push(key)),
    onGoBack: () => dispatch(goBack()),
});

export default connect(mapState, mapDispatch)(ApplicationExamDetailsContainer);

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
type IProps = connectedProps & OwnProps;

interface OwnProps {
    onPush: typeof push;
    examId: string;
    examApplicationId: string;
    withoutCard?: boolean;
}
